import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]

type Props = {
    labels: string[]
    asString?: boolean
    labelClick?: (index: number) => void
    customLabelClass?: string
    customWrapperClass?: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    labels: { type: Array, required: true },
    asString: { type: Boolean, required: false },
    labelClick: { type: Function, required: false },
    customLabelClass: { type: String, required: false },
    customWrapperClass: { type: String, required: false }
  },
  setup(__props: any) {

const props = __props as {
    labels: string[]
    asString?: boolean
    labelClick?: (index: number) => void
    customLabelClass?: string
    customWrapperClass?: string
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(`flex flex-row flex-wrap  ${props.customWrapperClass}`)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.labels, (label, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `label-${index}`,
        class: _normalizeClass({
                'label--regular': !props.asString,
                'label--as-string': props.asString,
            }),
        onClick: ($event: any) => (!isNaN(index) && __props.labelClick && __props.labelClick(index))
      }, [
        _createElementVNode("label", {
          class: _normalizeClass(props.customLabelClass)
        }, _toDisplayString(label) + _toDisplayString(props.asString && index !== props.labels.length - 1 ? ',' : ''), 3)
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}
}

})